export default __webpack_public_path__ + "static/media/payswitch-logo-black.962c1ed5.png";